<script setup lang="ts">
import BaseIcon from '@/components/base/baseIcon.vue'
import BaseLayout from '@/components/base/BaseLayout.vue'
import BasicContainer from '@/components/base/containers/BasicContainer.vue'
import TopContentContainerVer1 from '@/components/base/containers/TopContentContainerVer1.vue'
import ButtonPrimary from '@/components/buttons/ButtonPrimary.vue'
import NotificationCard from '@/components/card/NotificationCard.vue'
import SimpleCard from '@/components/card/reserach/SimpleCard.vue'
import SimpleResearchCard from '@/components/card/reserach/SimpleResearchCard.vue'
import linearLoadingCard from '@/components/loading/linearLoadingCard.vue'
import LoadingBlock from '@/components/loading/loadingBlock.vue'
import NoData from '@/components/state/NoData.vue'
import { iconNames } from '@/enums/iconNames'
import { pageNames } from '@/enums/pageNames'
import { researchStatus } from '@/enums/researchStatus'
import { getCommunityResearchList } from '@/service/communityResearch/research'
import { getTotalFollower } from '@/service/contributor/follower'
import { getNotification, setAsRead } from '@/service/notification/notification'
import { communityResearchDraftStore } from '@/stores/communityResearch/communityResearchDraft'
import { communityResearchPendingStore } from '@/stores/communityResearch/communityResearchPending'
import type { iCommunityResearch } from '@/stores/communityResearch/iCommunityResearch'
import { userProfileStore } from '@/stores/user/userProfile'
import moment from 'moment'
import { computed, onBeforeMount, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'

const img_url = import.meta.env.VITE_IMG_URL

interface iNotification {
  id: number
  readAt: Date | null
  title: string
  message: string
  module: string | null
  target_id: number
  created_at: Date
}

const router = useRouter()

const communityResearchPending = communityResearchPendingStore()
const communityResearchDraft = communityResearchDraftStore()

const totalFollower = ref<number>(0)

const notifications = ref<iNotification[]>([])
const userProfile = userProfileStore()
const fetchState = reactive({
  draft: true,
  approval: true,
  revision: true,
  approved: true,
  rejected: true,
  basicCount: true,
  notifState: true
})

onBeforeMount(async () => {
  getDraftList()
  getPendingList()
  // getNotificationList()
  countTotalFollower()
})

async function countTotalFollower() {
  fetchState.basicCount = true
  try {
    const result = await getTotalFollower()
    if (result?.data?.data?.totalFollow != null) {
      totalFollower.value = result.data.data.totalFollow
    }
  } catch (error) {
    console.error("Failed to fetch total follower:", error)
  }
  fetchState.basicCount = false
}
// deprecated another fungsi getNotificationList
// async function getNotificationList() {
//   const notificationList = (await getNotification()).data.data as iNotification[]
//   notifications.value = notificationList
//   const fiveMinutes = 5 * 60 * 1000 // 5 menit dalam ms
//   notificationList.forEach((notif) => {
//     if (notif.readAt) {
//       const readAtMoment = moment(notif.readAt)
//       const now = moment()
//       const diff = now.diff(readAtMoment) // dalam ms

//       if (diff >= fiveMinutes) {
//         // Sudah lebih dari 5 menit, langsung hapus
//         notifications.value = notifications.value.filter((n) => n.id !== notif.id)
//       } else {
//         // Belum 5 menit, jadwalkan penghapusan
//         const timeLeft = fiveMinutes - diff

//         // Optional log:
//         const duration = moment.duration(timeLeft)
//         console.log(`[${notif.id}] will be removed in ${duration.minutes()}m ${duration.seconds()}s`)

//         setTimeout(() => {
//           notifications.value = notifications.value.filter((n) => n.id !== notif.id)
//           console.log(`[${notif.id}] removed after timeout`)
//         }, timeLeft)
//       }
//     }
//   })
//   fetchState.notifState = false
async function getNotificationList() {
  fetchState.notifState = true
  try {
    const notificationList = await getNotification()
    const rawData = notificationList?.data?.data
    notifications.value = Array.isArray(rawData) ? rawData as iNotification[] : []
  } catch (error) {
    notifications.value = []
  }
  fetchState.notifState = false
}
async function getDraftList() {
  fetchState.draft = true
  try {
    const communityResearchList = await getCommunityResearchList(1, 10, researchStatus.DRAFT)
    const rawData = communityResearchList?.data?.data?.data
    const draftList = Array.isArray(rawData) ? rawData as iCommunityResearch[] : []
    communityResearchDraft.setcommunityResearchList(draftList)
  } catch (error) {
    communityResearchDraft.setcommunityResearchList([])
  }
  fetchState.draft = false
}
async function getPendingList() {
  fetchState.approval = true
  try {
    const communityResearchList = await getCommunityResearchList(1, 10, researchStatus.REQUEST)
    const rawData = communityResearchList?.data?.data?.data
    const draftList = Array.isArray(rawData) ? rawData as iCommunityResearch[] : []
    communityResearchPending.setcommunityResearchList(draftList)
  } catch (error) {
    communityResearchPending.setcommunityResearchList([])
  }
  fetchState.approval = false
}
async function readNotif(notif: iNotification) {
  if (notif.module === 'COMMUNITYRESEARCH') {
    setAsRead(notif.id)
    router.push({ name: pageNames.RESEARCHEDITOREXISTING, params: { id: notif.target_id } })
  }
}

const now = moment().utcOffset(7).subtract(5,'minutes')

const filteredNotification = computed(()=>{
  return notifications.value.filter((notif) => {
    if (notif.readAt) {
      return !now.isAfter(moment(notif.readAt)) // Hapus jika sudah lewat 5 menit sejak waktu (readAt)
    }
    return true // Notifikasi (readAt = null), biarkan tetap tampil
  })
})

async function getFilteredNotification() {
  await getNotificationList()
  notifications.value = notifications.value.filter((notif) => {
    if (notif.readAt) {
      return now.diff(moment(notif.readAt),'minutes') > 5 // Hapus jika sudah lewat 5 menit sejak waktu (readAt)
    }
    return true // Notifikasi (readAt = null), biarkan tetap tampil
  })
}
onMounted(async () => {
  await getFilteredNotification()
  const cleanupInterval = setInterval(async () => {
    await getFilteredNotification()
  }, 30000) // Jalankan setiap 30 detik untuk membersihkan yang sudah dibaca lebih dari 5 menit

  onUnmounted(() => {
    clearInterval(cleanupInterval) // Hentikan interval untuk mencegah memory leak
  })
})
</script>

<template>
  <BaseLayout>
    <template #content>
      <div class="flex flex-col base-box-layout items-center lg:items-start lg:pl-[24px]">
        <TopContentContainerVer1 v-if="!userProfile.isSubAccount" right-flex="lg:flex">
          <template #leftContent>
            <LoadingBlock :no-label="true" v-if="fetchState.basicCount" class="w-full lg:w-auto h-[148px] p-[16px] justify-center"/>
            <SimpleCard
              headText="Number of Followers"
              :content="totalFollower.toString()"
              bottomText=""
              v-if="!fetchState.basicCount"
              :hide-top-simple-icon="true"
            >
              <template #topCustomIcon>
                <!-- <BaseIcon :icon-name="iconNames.QUESTION" /> -->
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="28" height="28" rx="6" fill="#FEFCE8" />
                  <path
                    d="M21.3002 15.4C21.2477 15.4394 21.1879 15.4681 21.1243 15.4844C21.0607 15.5007 20.9945 15.5043 20.9295 15.495C20.8645 15.4857 20.8019 15.4637 20.7454 15.4302C20.6889 15.3968 20.6396 15.3525 20.6002 15.3C20.2988 14.8949 19.9066 14.5663 19.455 14.3405C19.0034 14.1147 18.5051 13.9981 18.0002 14C17.9019 14 17.8057 13.971 17.7238 13.9166C17.6419 13.8623 17.5778 13.785 17.5396 13.6944C17.5136 13.6329 17.5002 13.5668 17.5002 13.5C17.5002 13.4332 17.5136 13.3672 17.5396 13.3056C17.5778 13.215 17.6419 13.1377 17.7238 13.0834C17.8057 13.029 17.9019 13 18.0002 13C18.2807 13 18.5557 12.9213 18.7937 12.7728C19.0318 12.6244 19.2234 12.4122 19.3469 12.1603C19.4704 11.9084 19.5208 11.6269 19.4923 11.3478C19.4638 11.0687 19.3577 10.8032 19.1859 10.5814C19.0141 10.3596 18.7835 10.1905 18.5204 10.0931C18.2573 9.99583 17.9721 9.97426 17.6973 10.0309C17.4226 10.0875 17.1692 10.22 16.966 10.4134C16.7627 10.6068 16.6178 10.8534 16.5477 11.125C16.5313 11.1886 16.5025 11.2484 16.463 11.3009C16.4235 11.3533 16.374 11.3975 16.3174 11.4309C16.2608 11.4643 16.1982 11.4862 16.1332 11.4953C16.0681 11.5045 16.0019 11.5008 15.9383 11.4844C15.8747 11.468 15.815 11.4392 15.7625 11.3997C15.71 11.3602 15.6658 11.3107 15.6324 11.2541C15.5991 11.1975 15.5772 11.1349 15.568 11.0699C15.5588 11.0048 15.5625 10.9386 15.5789 10.875C15.6763 10.4983 15.8602 10.1496 16.1161 9.85648C16.3719 9.56339 16.6926 9.33406 17.0527 9.18673C17.4128 9.0394 17.8023 8.97815 18.1902 9.00784C18.5781 9.03753 18.9538 9.15735 19.2872 9.35777C19.6207 9.55818 19.9028 9.83365 20.1111 10.1623C20.3193 10.4909 20.448 10.8636 20.4869 11.2507C20.5258 11.6378 20.4738 12.0286 20.335 12.3921C20.1963 12.7556 19.9746 13.0817 19.6877 13.3444C20.3676 13.6388 20.9586 14.1059 21.4021 14.6994C21.4415 14.752 21.4701 14.812 21.4863 14.8757C21.5025 14.9394 21.506 15.0058 21.4965 15.0708C21.487 15.1359 21.4648 15.1985 21.4311 15.255C21.3974 15.3115 21.353 15.3607 21.3002 15.4ZM17.9327 19.25C17.9689 19.3069 17.9932 19.3706 18.0041 19.4371C18.015 19.5036 18.0124 19.5717 17.9964 19.6372C17.9803 19.7027 17.9512 19.7643 17.9107 19.8182C17.8703 19.8722 17.8193 19.9174 17.761 19.9511C17.7026 19.9849 17.638 20.0065 17.571 20.0146C17.5041 20.0227 17.4362 20.0172 17.3714 19.9984C17.3067 19.9797 17.2464 19.948 17.1942 19.9053C17.142 19.8626 17.0989 19.8098 17.0677 19.75C16.7527 19.2167 16.3041 18.7747 15.7662 18.4676C15.2283 18.1606 14.6196 17.9991 14.0002 17.9991C13.3808 17.9991 12.7721 18.1606 12.2342 18.4676C11.6962 18.7747 11.2477 19.2167 10.9327 19.75C10.9014 19.8098 10.8584 19.8626 10.8062 19.9053C10.754 19.948 10.6937 19.9797 10.629 19.9984C10.5642 20.0172 10.4963 20.0227 10.4294 20.0146C10.3624 20.0065 10.2978 19.9849 10.2394 19.9511C10.181 19.9174 10.1301 19.8722 10.0896 19.8182C10.0492 19.7643 10.02 19.7027 10.004 19.6372C9.98796 19.5717 9.98533 19.5036 9.99628 19.4371C10.0072 19.3706 10.0315 19.3069 10.0677 19.25C10.5524 18.4171 11.2916 17.7617 12.1764 17.38C11.6785 16.9988 11.3126 16.4711 11.1301 15.8712C10.9475 15.2712 10.9576 14.6291 11.1589 14.0352C11.3601 13.4413 11.7425 12.9253 12.2521 12.5599C12.7618 12.1945 13.3731 11.998 14.0002 11.998C14.6273 11.998 15.2386 12.1945 15.7483 12.5599C16.2579 12.9253 16.6402 13.4413 16.8415 14.0352C17.0428 14.6291 17.0528 15.2712 16.8703 15.8712C16.6878 16.4711 16.3219 16.9988 15.8239 17.38C16.7088 17.7617 17.4479 18.4171 17.9327 19.25ZM14.0002 17C14.3958 17 14.7824 16.8827 15.1113 16.6629C15.4402 16.4432 15.6966 16.1308 15.848 15.7654C15.9993 15.3999 16.0389 14.9978 15.9618 14.6098C15.8846 14.2219 15.6941 13.8655 15.4144 13.5858C15.1347 13.3061 14.7783 13.1156 14.3904 13.0384C14.0024 12.9613 13.6003 13.0009 13.2348 13.1523C12.8694 13.3036 12.557 13.56 12.3373 13.8889C12.1175 14.2178 12.0002 14.6044 12.0002 15C12.0002 15.5304 12.2109 16.0392 12.586 16.4142C12.961 16.7893 13.4698 17 14.0002 17ZM10.5002 13.5C10.5002 13.3674 10.4475 13.2402 10.3537 13.1465C10.26 13.0527 10.1328 13 10.0002 13C9.71964 13 9.44473 12.9213 9.20667 12.7728C8.96861 12.6244 8.77695 12.4122 8.65346 12.1603C8.52997 11.9084 8.4796 11.6269 8.50806 11.3478C8.53653 11.0687 8.6427 10.8032 8.81451 10.5814C8.98631 10.3596 9.21688 10.1905 9.48 10.0931C9.74313 9.99583 10.0283 9.97426 10.303 10.0309C10.5778 10.0875 10.8312 10.22 11.0344 10.4134C11.2376 10.6068 11.3826 10.8534 11.4527 11.125C11.4858 11.2535 11.5687 11.3635 11.6829 11.4309C11.7972 11.4983 11.9336 11.5175 12.0621 11.4844C12.1905 11.4512 12.3006 11.3684 12.368 11.2541C12.4354 11.1398 12.4546 11.0035 12.4214 10.875C12.3241 10.4983 12.1402 10.1496 11.8843 9.85648C11.6285 9.56339 11.3077 9.33406 10.9477 9.18673C10.5876 9.0394 10.1981 8.97815 9.81016 9.00784C9.42224 9.03753 9.04661 9.15735 8.71314 9.35777C8.37968 9.55818 8.09759 9.83365 7.88933 10.1623C7.68106 10.4909 7.55237 10.8636 7.51348 11.2507C7.4746 11.6378 7.5266 12.0286 7.66534 12.3921C7.80409 12.7556 8.02575 13.0817 8.31269 13.3444C7.63349 13.639 7.04314 14.1062 6.60019 14.6994C6.52054 14.8055 6.4863 14.9389 6.50499 15.0702C6.52369 15.2015 6.59379 15.3201 6.69988 15.3997C6.80596 15.4793 6.93935 15.5136 7.07068 15.4949C7.20201 15.4762 7.32054 15.4061 7.40019 15.3C7.70156 14.8949 8.09382 14.5663 8.54541 14.3405C8.997 14.1147 9.4953 13.9981 10.0002 14C10.1328 14 10.26 13.9473 10.3537 13.8536C10.4475 13.7598 10.5002 13.6326 10.5002 13.5Z"
                    fill="#CA8A04"
                  />
                </svg>
              </template>
            </SimpleCard>
          </template>
          <template #rightContent>
            <div class="sm:block hidden">
              <ButtonPrimary text="Create New Content" :pageName="pageNames.RESEARCHEDITORNEW" class="btn-xxl justify-between">
                <template #iconRight>
                  <BaseIcon :icon-name="iconNames.PLUS" :size="24" />
                </template>
              </ButtonPrimary>
            </div>
          </template>
        </TopContentContainerVer1>
        <BasicContainer :clean="true">
          <template #content>
            <div class="w-full flex flex-col gap-[24px]">
              <div class="flex flex-col xl:flex-row gap-[24px]">
                <div class="w-full p-[24px] bg-white border-[1px] rounded-[8px]">
                  <div class="flex">
                    <div class="grow text-[20px] font-bold">Draft Content</div>
                    <div
                      class="flex items-center content-center p-[6px] border-[1px] rounded-[6px] border-algo"
                      v-show="communityResearchDraft.getcommunityResearchList.length > 10"
                    >
                      <BaseIcon :icon-name="iconNames.GOTO" hex-color="#4448AB" />
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center gap-[16px] mt-[24px] h-[450px] overflow-y-hidden no-scrollbar-tib"
                    v-if="fetchState.draft"
                  >
                    <LoadingBlock />
                  </div>
                  <div
                    class="flex flex-col gap-[16px] mt-[24px] max-h-[450px] overflow-y-scroll no-scrollbar-tib"
                    v-else
                  >
                    <NoData v-if="communityResearchDraft.getcommunityResearchList.length < 1" />
                    <SimpleResearchCard
                      v-for="research in communityResearchDraft.getcommunityResearchList"
                      :key="'content-pending-' + research.id"
                      :research-id="research.id"
                      :research-title="research.article_title"
                      :research-category="
                        research.category !== null && research.category.deleted_at === null
                          ? research.category.article_category_name
                          : null
                      "
                      :publish-date="moment(research.published_at)"
                      :delete-date="research.deleted_at !== null ? moment(research.deleted_at) : null"
                      :contributor-name="userProfile.isSubAccount ? research.writter.fullname : userProfile.getUserProfile.fullname"
                      :contributor-img="
                        userProfile.getUserProfile.thumbnail
                          ? img_url + userProfile.getUserProfile.thumbnail
                          : '/img/default-avatar.png'
                      "
                      :related-tags="['Economic', 'IHSG', 'Gold', 'Bank', 'Company']"
                      :status="research.status"
                      :content-type="research.content_type"
                    />
                  </div>
                </div>
                <div class="w-full p-[24px] bg-white border-[1px] rounded-[8px]">
                  <div class="flex">
                    <div class="grow text-[20px] font-bold">Requested Content</div>
                    <div
                      class="flex items-center content-center p-[6px] border-[1px] rounded-[6px] border-algo"
                      v-show="communityResearchPending.getcommunityResearchList.length > 10"
                    >
                      <BaseIcon :icon-name="iconNames.GOTO" hex-color="#4448AB" />
                    </div>
                  </div>
                  <div
                    class="flex flex-col items-center justify-center gap-[16px] mt-[24px] h-[450px] overflow-y-hidden no-scrollbar-tib"
                    v-if="fetchState.approval"
                  >
                    <LoadingBlock />
                  </div>
                  <div
                    class="flex flex-col gap-[16px] mt-[24px] max-h-[450px] overflow-y-scroll no-scrollbar-tib"
                    v-else
                  >
                    <NoData v-if="communityResearchPending.getcommunityResearchList.length < 1" />
                    <SimpleResearchCard
                      v-for="research in communityResearchPending.getcommunityResearchList"
                      :key="'content-pending-' + research.id"
                      :research-id="research.id"
                      :research-title="research.article_title"
                      :research-category="research.category?.article_category_name || ''"
                      :publish-date="moment(research.published_at)"
                      :delete-date="research.deleted_at !== null ? moment(research.deleted_at) : null"
                      :contributor-name="userProfile.isSubAccount ? research.writter.fullname : userProfile.getUserProfile.fullname"
                      :contributor-img="
                        userProfile.getUserProfile.thumbnail
                          ? img_url + userProfile.getUserProfile.thumbnail
                          : '/img/default-avatar.png'
                      "
                      :related-tags="['Economic', 'IHSG', 'Gold', 'Bank', 'Company']"
                      :status="research.status"
                      :content-type="research.content_type"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-span-2 p-[24px] bg-white border-[1px] rounded-[8px] flex flex-col gap-[8px]"
                v-show="filteredNotification.length > 0 || fetchState.notifState"
              >
                <div class="text-[30px] font-semibold mb-[24px]" v-show="fetchState.notifState">
                  Notifications Center
                </div>
                <!-- read notif -->
                <div class="h-[80px] w-full mb-[12px]" v-show="fetchState.notifState">
                  <linearLoadingCard body-class="rounded-[6px]" />
                </div>
                <div class="h-[80px] w-full mb-[12px]" v-show="fetchState.notifState">
                  <linearLoadingCard body-class="rounded-[6px]" />
                </div>
                <div class="h-[80px] w-full mb-[12px]" v-show="fetchState.notifState">
                  <linearLoadingCard body-class="rounded-[6px]" />
                </div>
                <NotificationCard
                  v-for="notif in filteredNotification"
                  :key="`notif-${notif.id}`"
                  @clicked="() => {
                      readNotif(notif)
                    }"
                  :read-at="notif.readAt ? new Date(notif.readAt) : null"
                  :title="notif.title"
                  :message="notif.message"
                  :created_at="notif.created_at ? new Date(notif.created_at) : null"
                />
              </div>
            </div>
          </template>
        </BasicContainer>
      </div>
    </template>
  </BaseLayout>
</template>
<style>
/* page settings */
.base-box-layout {
  background: var(--Accent-Color-Slate-50, #f8fafc);
  padding-top: 24px;
  padding-bottom: 24px;
}

/* item box setting */
</style>
